module.exports = __webpack_public_path__ + "img/tmf2026_album.3e8ded4e.jpg";